<script lang="ts">
  import { orgUser } from "@nrk/origo";
  import ImageGroup from "components/SearchPage/ImageGroup.svelte";
  import { getBildebankenHost } from "config";
  import { getDefaultSearchParams } from "state/params";
  import { getSearchHitsFromQuery } from "state/queries";
  import { createMimirSearchQuery } from "state/queries/mimir";
  import { fade } from "svelte/transition";
  import { formatRelativeDate } from "utils/fns";
  export let job: {
    title: string;
    id: string;
    updatedAt: Date;
    photographer: string;
    username: string;
  };
  $: infiniteQuery = createMimirSearchQuery({
    ...getDefaultSearchParams(),
    filter: { jobId: job.id },
  });
  $: images = getSearchHitsFromQuery(infiniteQuery);
  function createJobIdSearchLink() {
    return new URL(`/images?jobId=${job.id}`, getBildebankenHost()).toString();
  }
</script>

<div transition:fade|local={{ duration: 200 }} class="job-group">
  <div class="job-header">
    <h3><a href={createJobIdSearchLink()}>{job.title}</a></h3>
    <small
      ><span style="font-size:0.6rem;">{@html orgUser}</span>
      {job.photographer} - Sist oppdatert: {formatRelativeDate(new Date(job.updatedAt))}</small
    >
  </div>
  <div class="job-images">
    {#if $images.length > 0}
      <ImageGroup images={$images} showRelativeTime={true} />
    {:else}
      <p>Ingen bilder enda</p>
    {/if}
  </div>
</div>

<style>
  .job-group {
    margin: var(--org-medium);
    width: 80%;
    background: var(--org-color-shade-1);
    border-radius: var(--org-xsmall);
  }
  .job-header {
    height: var(--org-large);
    padding-left: var(--org-small);
    padding-right: var(--org-small);
    background: var(--color-surface-secondary);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .job-images {
    padding: var(--org-medium);
    width: auto;
  }
</style>
